import { Droppable } from "react-beautiful-dnd";
import memoizeOne from "memoize-one";
import ScenesWithoutDayScene from "./scenes-without-days-scene";

const ScenesWithoutDays = (props) => {
    const { scenes, readOnly, toggleSelectionInGroup, multiSelectTo, toggleSelection, draggingSceneId, selectedSceneIds, colorCode, onDeleteSceneInstance, duplicatedSceneInstanceIds, days } = props;

    type SceneIdMap = {
        [sceneId: string]: true;
    };

    const getSelectedMap = memoizeOne((selectedSceneIds: string[]) =>
        selectedSceneIds.reduce(
            (previous: SceneIdMap, current: string): SceneIdMap => {
                previous[current] = true;
                return previous;
            },
            {}
        )
    );

    return (
        <div className="sticky">
            <table className="table">
                <thead>
                    <tr>
                        <th>Unscheduled Days</th>
                        <th></th>
                    </tr>
                </thead>

                <Droppable droppableId={"newScene"} type="scene">
                    {(provided, snapshot) => (
                        <tbody  {...provided.droppableProps}
                            ref={provided.innerRef}>
                            {(scenes || []).map((scene, index) => {
                                const selectionMap = getSelectedMap(
                                    selectedSceneIds || []
                                );
                                const isSelected = selectionMap
                                    ? selectionMap[scene.sceneId]
                                    : false;
                                const isGhosting =
                                    isSelected &&
                                    draggingSceneId &&
                                    draggingSceneId !== scene.sceneId;

                                // Count total instances of this scene across all days and scenesWithoutDays
                                const sceneInstanceCount = (days || []).reduce((count: number, day: any) => {
                                    return count + (day.scenes || []).filter((s: any) => s.sceneId === scene.sceneId).length;
                                }, 0) + (scenes || []).filter(s => s.sceneId === scene.sceneId).length;

                                const canDeleteScene = sceneInstanceCount > 1;

                                return (
                                    <ScenesWithoutDayScene scene={scene}
                                        index={index}
                                        readOnly={readOnly}
                                        toggleSelectionInGroup={toggleSelectionInGroup}
                                        multiSelectTo={multiSelectTo}
                                        toggleSelection={toggleSelection}
                                        selectedSceneIds={selectedSceneIds}
                                        draggingSceneId={draggingSceneId}
                                        isSelected={isSelected}
                                        isGhosting={isGhosting}
                                        colorCode={colorCode}
                                        onDeleteSceneInstance={onDeleteSceneInstance}
                                        canDeleteScene={canDeleteScene}
                                        sceneInstanceCount={sceneInstanceCount}
                                    />
                                )
                            }
                            )}
                            {provided.placeholder}
                        </tbody>)}
                </Droppable>
            </table>
        </div>
    )
}

export default ScenesWithoutDays;